import moment from "moment";
import { globals, page as pageIndex } from "../../globals";
import { logOut } from "./auth";
import { showModal } from "./modal";
import { clearHistory, saveInitialValues } from "./undo";
import { actionHandler, UPDATE_DATA } from "./updateData";
// ------------------------------------
// Constants
// ------------------------------------
export const GET_REGISTER_QUEUE_START = "GET_REGISTER_QUEUE_START";
export const GET_REGISTER_QUEUE_FETCHED = "GET_REGISTER_QUEUE_FETCHED";
export const GET_REGISTER_QUEUE_FAILURE = "GET_REGISTER_QUEUE_FAILURE";
export const GET_REGISTER_RECORD_START = "GET_REGISTER_RECORD_START";
export const GET_REGISTER_RECORD_FETCHED = "GET_REGISTER_RECORD_FETCHED";
export const GET_REGISTER_RECORD_FAILURE = "GET_REGISTER_RECORD_FAILURE";
export const FILTER_BY_COUNTRY = "FILTER_BY_COUNTRY";
export const SAVE_REGISTER_START = "SAVE_REGISTER_START";
export const REGISTER_SAVED = "REGISTER_SAVED";
export const SAVE_REGISTER_FAILURE = "SAVE_REGISTER_FAILURE";
export const CREATE_REGISTER_START = "CREATE_REGISTER_START";
export const REGISTER_CREATED = "REGISTER_CREATED";
export const CREATE_REGISTER_FAILURE = "CREATE_REGISTER_FAILURE";
export const UPDATE_REGISTER_START = "UPDATE_REGISTER_START";
export const REGISTER_UPDATED = "REGISTER_UPDATED";
export const UPDATE_REGISTER_FAILURE = "UPDATE_REGISTER_FAILURE";
export const DELETE_REGISTER_START = "DELETE_REGISTER_START";
export const REGISTER_DELETED = "REGISTER_DELETED";
export const DELETE_REGISTER_FAILURE = "DELETE_REGISTER_FAILURE";
export const REGISTER_EXISTS = "REGISTER_EXISTS";
export const RETURN_REGISTER_DEFAULT = "RETURN_REGISTER_DEFAULT";
export const GET_INITIAL_REGISTER_FOR_QUERY = "GET_INITIAL_REGISTER_FOR_QUERY";
// ------------------------------------
// Actions
// ------------------------------------
const headers = {
  "Content-Type": "application/json",
};

function returnTypesForQueue(types) {
  if (types) {
    return types.map((item) => `&notestypes=${item}`).join("");
  } else return "";
}

export function getRegisterReviewQueue(
  actionType,
  searchDate,
  searchTerm,
  notesTypes,
  reviewer,
  seekToRegisterId = null
) {
  return (dispatch) => {
    dispatch({ type: GET_REGISTER_QUEUE_START });
    const options = {
      method: "GET",
      credentials: "include",
      headers,
    };
    const newDateSearch =
      searchDate && searchDate !== " " && searchDate !== "Invalid date"
        ? `&searchdate=${moment(searchDate).format("YYYY-MM-DD")}`
        : "";
    const newSearchTerm = searchTerm ? `&searchterm=${searchTerm}` : "";
    const newTypes = returnTypesForQueue(notesTypes);
    const review = actionType !== 0 ? `&reviewer=${reviewer || ""}` : "";
    const params = `${newDateSearch}${newSearchTerm}${newTypes}${review}`;
    return fetch(
      `${globals.apiUrl}/registerreview?actiondatetype=${actionType}${params}`,
      options
    )
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          return dispatch(logOut());
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_REGISTER_QUEUE_FETCHED,
            payload: {
              json,
              actionType,
              newDateSearch,
            },
          });

          let registerIndex = 0;

          if (json.length === 0) {
            dispatch(showModal("No-results"));
            dispatch({ type: RETURN_REGISTER_DEFAULT });
          } else {
            registerIndex = seekToRegisterId
              ? json.findIndex((register) => {
                  return register.RegisterReviewId === seekToRegisterId;
                })
              : 0;

            dispatch(getRegisterRecord(json[registerIndex], actionType));
          }

          return registerIndex;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: GET_REGISTER_QUEUE_FAILURE });
      });
  };
}

export function getRegisterRecord(record, actionType) {
  return (dispatch) => {
    dispatch({ type: GET_REGISTER_RECORD_START });
    const options = {
      method: "GET",
      credentials: "include",
      headers,
    };
    return fetch(
      `${globals.apiUrl}/registerreview/${record.RegisterReviewId}?actiondatetype=${actionType}`,
      options
    )
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          return dispatch(logOut());
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_REGISTER_RECORD_FETCHED,
            payload: {
              json,
              id: record.RegisterReviewId,
              url: record.Url,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: GET_REGISTER_RECORD_FAILURE });
      });
  };
}

export function saveRegisterChanges(
  parameters,
  trackData,
  openParameters,
  formData
) {
  return (dispatch) => {
    dispatch({ type: SAVE_REGISTER_START });
    const options = {
      method: "PUT",
      credentials: "include",
      headers,
      body: JSON.stringify(parameters),
    };
    fetch(`${globals.apiUrl}/registerreview`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 400) {
          return response.text().then((text) => {
            if (text.includes("Please refresh data")) {
              dispatch(showModal("Time-out-modal"));
            } else {
              dispatch(showModal("Error", { errorMessage: text }));
            }
          });
        } else if (response.status === 401) {
          return dispatch(logOut());
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: REGISTER_SAVED,
            payload: {
              json,
            },
          });
          if (localStorage.getItem("signOut")) {
            dispatch(logOut());
            localStorage.removeItem("signOut");
          }
          dispatch(clearHistory(pageIndex.registerReview));
          dispatch(saveInitialValues(pageIndex.registerReview, trackData));
          if (openParameters) {
            const state = trackData.statesDD.radio.state;
            const url = trackData.statesDD.textValues.url;
            const record = formData.allRecords.find(
              (item) =>
                item.State === state &&
                item.Url === url &&
                item.RegisterReviewId === parameters.id
            );
            if (record) {
              const reviewer = trackData.parametersSection.textValues.reviewer;
              const actionType = trackData.queryLine.radio.query;
              dispatch(
                getRegisterReviewQueue(actionType, null, null, null, reviewer)
              );
            } else {
              dispatch(
                getRegisterRecord(
                  openParameters.record,
                  openParameters.actionType
                )
              );
            }
          }
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: SAVE_REGISTER_FAILURE });
      });
  };
}

function returnDate(date) {
  if (date) {
    return moment(date).format("MMM / DD / YYYY");
  } else return " ";
}

function returnStates(states, countryType) {
  let newStates = [];
  if (countryType === "All") {
    let getCountries = states.map((item) => item.CountryCode);
    getCountries = new Set(getCountries);
    getCountries = Array.from(getCountries.values());
    for (let i = 0; i < getCountries.length; i++) {
      if (getCountries[i]) {
        newStates = [
          ...newStates,
          ...returnCountryStates(getCountries[i], states),
        ];
      }
    }
  } else {
    newStates = [...newStates, ...returnCountryStates(countryType, states)];
  }
  const transformedArray = newStates.map((item) => {
    return {
      label: item.NRREnabled ? `${item.RegionShortName} - ${item.RegionLongName} **` : `${item.RegionShortName} - ${item.RegionLongName}`,
      value: item.RegionShortName,
      upFlag: item.NRREnabled,
    };
  });
  return transformedArray;
}

function returnCountryStates(country, countryRegions) {
  let states = [];
  let checkDuplicates = [];
  if (countryRegions) {
    countryRegions.map((item) => {
      if (
        country === item.CountryCode &&
        !checkDuplicates.includes(
          `${item.RegionShortName} - ${item.RegionLongName}`
        )
      ) {
        checkDuplicates = [
          ...checkDuplicates,
          `${item.RegionShortName} - ${item.RegionLongName}`,
        ];
        states = [...states, item];
      }
    });
  }
  return states;
}

export function filterByCountry(states, country) {
  const newRegions = returnStates(states, country);
  return (dispatch) => {
    if (newRegions.length !== 0) {
      dispatch({
        type: "FILTER_BY_COUNTRY",
        payload: {
          json: newRegions,
          countryCode: country,
        },
      });
    } else {
      dispatch(showModal("No-results"));
    }
  };
}

export function createRegister(registerInfo) {
  return (dispatch) => {
    dispatch({ type: CREATE_REGISTER_START });
    const options = {
      method: "POST",
      credentials: "include",
      headers,
      body: JSON.stringify(registerInfo),
    };
    return fetch(`${globals.apiUrl}/register`, options)
      .then((response) => {
        if (response.status === 409) {
          response.json().then((json) => {
            if (json) {
              dispatch({
                type: REGISTER_EXISTS,
                payload: {
                  json,
                },
              });
              dispatch(showModal("Duplicate-modal"));
            }
          });
        } else if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          return dispatch(logOut());
        }
      })
      .then((json) => {
        if (json) {
          dispatch(
            getRegisterReviewQueue(
              0,
              null,
              null,
              null,
              null,
              json.RegisterReviewId
            )
          );

          dispatch({
            type: REGISTER_CREATED,
            payload: {
              json,
            },
          });

          return json.RegisterReviewId;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: CREATE_REGISTER_FAILURE });
      });
  };
}

export function updateRegister(registerInfo) {
  return (dispatch) => {
    dispatch({ type: UPDATE_REGISTER_START });
    const options = {
      method: "PUT",
      credentials: "include",
      headers,
      body: JSON.stringify(registerInfo),
    };
    fetch(`${globals.apiUrl}/register`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          return dispatch(logOut());
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: REGISTER_UPDATED,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: UPDATE_REGISTER_FAILURE });
      });
  };
}

export function deleteRegister(registerId) {
  return (dispatch) => {
    dispatch({ type: DELETE_REGISTER_START });
    const options = {
      method: "DELETE",
      credentials: "include",
      headers,
    };
    fetch(`${globals.apiUrl}/register/${registerId}`, options)
      .then((response) => {
        if (response.status === 200) {
          dispatch({
            type: REGISTER_DELETED,
            payload: {
              registerId,
            },
          });
        } else if (response.status === 401) {
          return dispatch(logOut());
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: DELETE_REGISTER_FAILURE });
      });
  };
}

export function getInitialStateForNewQuery() {
  return {
    type: GET_INITIAL_REGISTER_FOR_QUERY,
  };
}
// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [UPDATE_DATA]: (state, action) =>
    action.location.page !== pageIndex.registerReview
      ? state
      : actionHandler(state, action),
  [GET_REGISTER_QUEUE_START]: (state) => {
    return {
      ...state,
      isFetchingData: true,
    };
  },
  [GET_REGISTER_QUEUE_FETCHED]: (state, action) => {
    const { json, actionType, newDateSearch } = action.payload;
    const countryType = state.formDataValue.RR.statesDD.radio.country;
    const states = returnStates(json, actionType === 0 ? "All" : countryType);
    const query = state.formDataValue.RR.queryLine.radio.query;
    return {
      ...state,
      isFetchingData: false,
      disableRegister: false,
      renderData: {
        ...state.renderData,
        amountOfRecords:
          countryType !== "All"
            ? json.filter((item) => item.CountryCode === countryType)
            : json,
        allRecords: json,
        registerRegions: states,
      },
      formDataValue: {
        RR: {
          ...state.formDataValue.RR,
          navigation: {
            textValues: {
              currentRecord: 1,
            },
          },
          statesDD: {
            ...state.formDataValue.RR.statesDD,
            radio: {
              ...state.formDataValue.RR.statesDD.radio,
              country: query === 0 ? "All" : countryType,
              state:
                json.length !== 0
                  ? json[0].State
                  : state.formDataValue.RR.statesDD.radio.state,
            },
          },
          queryLine: {
            ...state.formDataValue.RR.queryLine,
            dateTime: {
              filterDate: newDateSearch
                ? state.formDataValue.RR.queryLine.dateTime.filterDate
                : " ",
            },
            selected: state.formDataValue.RR.queryLine.selected.filter(
              (item) => typeof item === "string"
            ),
          },
        },
      },
    };
  },
  [GET_REGISTER_RECORD_START]: (state) => {
    return {
      ...state,
      isFetchingData: true,
    };
  },
  [GET_REGISTER_RECORD_FETCHED]: (state, action) => {
    const { json, id, url } = action.payload;
    const records = state.renderData.amountOfRecords;
    const register =
      records && records.length !== 0
        ? records.find(
            (item) => item.RegisterReviewId === id && item.Url === url
          )
        : "0";
    const index = register
      ? records.findIndex(
          (item) => register.RegisterReviewId === item.RegisterReviewId
        )
      : null;
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        registerReviewRecord: json,
      },
      formDataValue: {
        RR: {
          ...state.formDataValue.RR,
          navigation: {
            textValues: {
              currentRecord: index + 1,
            },
          },
          statesDD: {
            ...state.formDataValue.RR.statesDD,
            radio: {
              ...state.formDataValue.RR.statesDD.radio,
              state: json.State || "Select State",
            },
            textValues: {
              url: json.Url || "",
              frequency: json.ReviewFreq || "",
              toolbox: json.ToolboxUrl || "",
            },
          },
          url: {
            textValues: {
              urlInput: json.Url || "",
              frequency: json.ReviewFreq || "",
            },
          },
          textBlocks: {
            textValues: {
              generalNotes: json.Notes || "",
              team1Reviewer: json.ReviewerTeam1 || "",
              team2Reviewer: json.ReviewerTeam2 || "",
              team3Reviewer: json.ReviewerTeam3 || "",
              team1Notes: json.Team1Note || "",
              team2Notes: json.Team2Note || "",
              team3Notes: json.Team3Note || "",
              log: json.ReviewHistory || "",
            },
          },
          dates: {
            dateTime: {
              team1Date: returnDate(json.Team1NextActionDate),
              team2Date: returnDate(json.Team2NextActionDate),
              team3Date: returnDate(json.Team3NextActionDate),
            },
          },
        },
      },
    };
  },
  [FILTER_BY_COUNTRY]: (state, action) => {
    const { json, countryCode } = action.payload;
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        registerRegions: json,
        amountOfRecords:
          countryCode === "All"
            ? state.renderData.allRecords
            : state.renderData.allRecords.filter(
                (item) => item.CountryCode === countryCode
              ),
      },
      formDataValue: {
        RR: {
          ...state.formDataValue.RR,
          statesDD: {
            ...state.formDataValue.RR.statesDD,
            radio: {
              ...state.formDataValue.RR.statesDD.radio,
              state: json[0].value,
            },
          },
        },
      },
    };
  },
  [REGISTER_UPDATED]: (state, action) => {
    const { json } = action.payload;
    const newQueue = state.renderData.amountOfRecords.map((item) => {
      if (item.RegisterReviewId === json.RegisterReviewId) {
        return {
          Url: json.Url,
          ReviewFrequency: json.ReviewFrequency,
          CountryCode: item.CountryCode,
          RegionLongName: item.RegionLongName,
          RegionShortName: json.RegionShortName,
          RegisterReviewId: json.RegisterReviewId,
          ToolboxUrl:
            json.ToolboxUrl ||
            state.formDataValue.RR.editRegisters.textValues.toolbox,
        };
      } else return item;
    });
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        amountOfRecords: newQueue,
        allRecords: newQueue,
      },
    };
  },
  [REGISTER_EXISTS]: (state, action) => {
    const { json } = action.payload;
    return {
      ...state,
      renderData: {
        ...state.renderData,
        duplicatedRegister: json,
      },
    };
  },
  [REGISTER_CREATED]: (state, action) => {
    const { json } = action.payload;
    return {
      ...state,
      renderData: {
        ...state.renderData,
        newRegister: json,
      },
      formDataValue: {
        RR: {
          ...initialState.formDataValue.RR,
          statesDD: {
            ...state.formDataValue.RR.statesDD,
            textValues: {
              url: json.Url,
              frequency: json.ReviewFrequency,
              toolbox: json.ToolboxUrl,
            },
          },
        },
      },
    };
  },
  [REGISTER_DELETED]: (state, action) => {
    const { registerId } = action.payload;
    const newQueue = state.renderData.amountOfRecords.filter(
      (item) => item.RegisterReviewId !== registerId
    );
    return {
      ...state,
      renderData: {
        ...state.renderData,
        allRecords: newQueue,
        amountOfRecords: newQueue,
      },
    };
  },
  [REGISTER_SAVED]: (state) => {
    return {
      ...state,
      renderData: {
        ...state.renderData,
      },
    };
  },
  [RETURN_REGISTER_DEFAULT]: (state) => {
    return {
      ...initialState,
      disableRegister: true,
      formDataValue: {
        RR: {
          ...initialState.formDataValue.RR,
          queryLine: {
            ...state.formDataValue.RR.queryLine,
          },
          parametersSection: {
            textValues: {
              reviewer:
                state.formDataValue.RR.parametersSection.textValues.reviewer,
            },
          },
        },
      },
    };
  },
  [GET_INITIAL_REGISTER_FOR_QUERY]: (state) => {
    return {
      ...initialState,
      disableRegister: true,
      formDataValue: {
        RR: {
          ...initialState.formDataValue.RR,
          queryLine: {
            ...initialState.formDataValue.RR.queryLine,
            radio: {
              query: state.formDataValue.RR.queryLine.radio.query,
            },
          },
        },
      },
    };
  },
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  errorCode: "",
  renderData: {},
  formDataValue: {
    RR: {
      queryLine: {
        radio: {
          query: 0,
        },
        dateTime: {
          filterDate: " ",
        },
        textValues: {
          keywordSearch: "",
        },
        selected: [],
      },
      parametersSection: {
        textValues: {
          reviewer: "",
        },
      },
      navigation: {
        textValues: {
          currentRecord: "1",
        },
      },
      statesDD: {
        radio: {
          state: "",
          country: "All",
        },
        textValues: {
          url: "",
          frequency: "",
          toolbox: "",
        },
      },
      editRegisters: {
        radio: {
          state: "",
          country: "",
        },
        textValues: {
          url: "",
          frequency: "",
          toolbox: "",
        },
      },
      url: {
        textValues: {
          urlInput: "",
          frequency: "",
        },
      },
      dates: {
        dateTime: {
          team1Date: " ",
          team2Date: " ",
          team3Date: " ",
        },
      },
      textBlocks: {
        textValues: {
          generalNotes: "",
          team1Reviewer: "",
          team2Reviewer: "",
          team3Reviewer: "",
          team1Notes: "",
          team2Notes: "",
          team3Notes: "",
          log: "",
        },
      },
    },
  },
};
export default function registerReviewReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/store/reducers/registerReviewData.js